import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useGetReturnsQuery,
  useRemoveReturnMutation,
} from "../../features/api/returnApi";
import { useRemoveReturnlistMutation } from "../../features/api/returnlistApi";
import { useGetDealersQuery } from "../../features/api/dealerApi";

const ReturnProduct = () => {
  const { data, error, isLoading } = useGetReturnsQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const returns2 = data?.returnTwo;

  const { data: dlr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = dlr?.dealer;

  const sortedreturns2 = returns2?.slice().sort((a, b) => b?.id - a?.id);

  const [removeReturn] = useRemoveReturnMutation();
  // const [removeSaleslistItem] = useRemoveSaleslistMutation();
  const [removeReturnlist] = useRemoveReturnlistMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeReturn(id);
        console.log(result?.error?.error);
        //  const result2= await removeSaleslistItem(id);
        const result2 = await removeReturnlist(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error?.status);
      }
    }
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchChange = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);

    const filteredResults = returns2?.filter((item) =>
      item?.inv_no.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(filteredResults);
  };

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let getDate = day + "-" + month + "-" + year;
    return getDate;
  }

  return (
    <div>
      <div className="flex justify-between items-center px-12 my-4">
        <h1 className="text-xl font-bold">Sales Return</h1>
        <Link
          to="/dashboard/returnProduct/create"
          className="text-white bg-blue-500 cursor-pointer flex items-center p-1"
        >
          {" "}
          <span>
            <MdAdd className="text-2xl" />
          </span>
          <span>New Return</span>
        </Link>
      </div>
      <input
        type="text"
        placeholder="Search items"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={handleSearchChange}
      />
      <div className="h-[75vh] overflow-auto max-w-sm lg:max-w-[960px] m-auto">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : returns2?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no Return invoice
          </p>
        ) : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell> */}
                  <TableCell>
                    <span className="font-bold">Return No.</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Return Date</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Return Invoice</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Dealer</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Return Amount</span>
                  </TableCell>
                  <TableCell>
                    <span className="font-bold">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchTerm
                  ? searchResults
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => {
                        const dName = dealers?.find(
                          (dlr) => dlr?.id === row?.dealer
                        );
                        const passData={row,dName}
                        return (
                          <TableRow key={row.id}>
                            {/* <TableCell>{i + 1}</TableCell> */}
                            <TableCell>{row?.return_no}</TableCell>
                            <TableCell>
                              {formatDate(row?.return_date)}
                            </TableCell>
                            <TableCell>
                              {row?.return_inv
                                ? row.return_inv
                                : "No Available"}
                            </TableCell>
                            <TableCell>{dName?.d_name}</TableCell>
                            <TableCell>{row?.total}</TableCell>
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                {/* <Link to="/dashboard/updatePurchase" state={row}>
                        <span>
                          <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
                        </span>
                      </Link> */}
                                <span
                                  onClick={() => handleDelete(row?.return_no)}
                                >
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                                <Link
                                  to="/dashboard/returnProduct/invoice"
                                  state={passData}
                                >
                                  <span className=" underline text-blue-600">
                                    Invoice
                                  </span>
                                </Link>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })
                  : sortedreturns2
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((row, i) => {
                        const dName = dealers?.find(
                          (dlr) => dlr?.id === row?.dealer
                        );
                        const passData={row,dName}
                        return (
                          <TableRow key={row?.id}>
                            <TableCell>{row?.return_no}</TableCell>
                            <TableCell>
                              {formatDate(row?.return_date)}
                            </TableCell>
                            <TableCell>
                              {row?.return_inv
                                ? row?.return_inv
                                : "No-Available"}
                            </TableCell>
                            <TableCell>{dName?.d_name}</TableCell>
                            <TableCell>{row?.total}</TableCell>
                            <TableCell className="">
                              <div className="flex items-center gap-x-4">
                                {/* <Link to="/dashboard/updatePurchase" state={row}>
                        <span>
                          <FaEdit className="text-xl text-blue-500 font-bold cursor-pointer" />
                        </span>
                      </Link> */}
                                <span
                                  onClick={() => handleDelete(row?.return_no)}
                                >
                                  <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                                </span>
                                <Link
                                  to="/dashboard/returnProduct/invoice"
                                  state={passData}
                                >
                                  <span className=" underline text-blue-600">
                                    Invoice
                                  </span>
                                </Link>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={returns2?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default ReturnProduct;